module.exports = __webpack_public_path__ + "static/media/ss-mobile-1-mockup.d78b4ddd.png";